module.exports = __webpack_public_path__ + "img/111.9baf83f1.png";